namespace Matrix.Data {
    export interface EventLogForm {
        EventType: Serenity.StringEditor;
        Message: Serenity.TextAreaEditor;
        Action: Serenity.StringEditor;
        RowsAffected: Serenity.StringEditor;
        RowId: Serenity.StringEditor;
        Version: Serenity.IntegerEditor;
        CreatedBy: Serenity.StringEditor;
        CreatedWhen: Serenity.StringEditor;
    }

    export class EventLogForm extends Serenity.PrefixedContext {
        static formKey = 'Data.EventLog';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!EventLogForm.init)  {
                EventLogForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.TextAreaEditor;
                var w2 = s.IntegerEditor;

                Q.initFormType(EventLogForm, [
                    'EventType', w0,
                    'Message', w1,
                    'Action', w0,
                    'RowsAffected', w0,
                    'RowId', w0,
                    'Version', w2,
                    'CreatedBy', w0,
                    'CreatedWhen', w0
                ]);
            }
        }
    }
}
